import ViewDriveRole from 'modules/Drives/ViewDriveRole/index'
import {
  createInterview,
  getCities,
  getDegreeAndDepartMent,
  getDriveInterviewerList,
  getDriveRoleCandidatesList,
  getDriveRoleMetrics,
  getGroupCandidateList,
  getGroupDiscussionList,
  getRoleMetrics,
  getSingleCandidateInterviewDetails,
  getcollegeList,
  releaseOfferAPI,
  updateInterviewStatus,
  fileUpload,
  getNewDriveFreshersList,
  getNewDriveStatus,
  getNewDriveScore,
  getNewIndividualDriveStatus,
  getPanelList,
  resumeBulkDownloadJobRoles as resumeBulkDownload,
} from 'modules/Drives/actions'
import {
  getCandidateScoreList,
  postShortlistCandidates,
  getTopicsList,
  postPassingScore,
} from 'modules/Exp-Candidates/actions'
import driveSelector from 'modules/Drives/selectors'
import { getCandidateDetails, getSingleRoleData } from 'modules/Roles/actions'
import rolesSelectors from 'modules/Roles/selectors'
import { connect } from 'react-redux'
import {
  getRounds,
  getStatus,
  getYear,
  getCollegeListForFilter,
  getSkillForFilter,
  getQuestionForFilter,
  getCustomQuestionFilterOptions,
  getWorkExperienceForFilter,
  getLocationForFilter,
  getDegreeForFilter,
  downloadTemplate,
  uploadShorlistResult,
  getExportFiledData,
  atsExportCandidate,
  getConflictCandidates,
  updateResolveConflictCandidates,
} from '../actions'
import reportSelectors from 'modules/Report/selectors.js'
import { addNewRound, updateNewRound } from '../actions'

const mapStateToProps = state => ({
  driveRolesMetrics: driveSelector.getDriveRoleMetrics(state),
  rolesMetrics: driveSelector.getRoleMetrics(state),
  degreeList: driveSelector.getDegreeList(state),
  driveData: driveSelector.getDriveData(state),
  driveInterViewerList: driveSelector.getDriveInterViewerList(state),
  collegeList: driveSelector.getCollegeList(state),
  candidateDetails: rolesSelectors.getCandidateDetails(state),
  candidateInterviewDetails: driveSelector.getCandidateInterviewDetails(state),
  groupList: driveSelector.getGroupList(state),
  groupCandidateList: driveSelector.getGroupCandidateList(state),
  cityList: driveSelector.getCityList(state),
  singleRoleData: rolesSelectors.getSingleRoleData(state),
  newFreshersListData: driveSelector.getFreshersList(state),
  newDriveStatusData: driveSelector.getNewDriveStatus(state),
  newDriveScoreData: driveSelector.getNewDriveScore(state),
  newDriveScore: driveSelector.getNewDriveMetrics(state),
  roundData: reportSelectors.getRoundData(state),
  statusList: driveSelector.getStatusList(state),
})

const mapDispatchToProps = {
  getDriveRoleMetrics,
  getDriveRoleCandidatesList,
  getRoleMetrics,
  getDegreeAndDepartMent,
  createInterview,
  getDriveInterviewerList,
  getcollegeList,
  getCandidateDetails,
  getSingleCandidateInterviewDetails,
  getGroupDiscussionList,
  getGroupCandidateList,
  updateInterviewStatus,
  getCities,
  releaseOfferAPI,
  getSingleRoleData,
  fileUpload,
  getCandidateScoreList,
  postShortlistCandidates,
  getTopicsList,
  postPassingScore,
  getNewDriveFreshersList,
  getNewDriveStatus,
  getNewDriveScore,
  getNewIndividualDriveStatus,
  getPanelList,
  resumeBulkDownload,
  getRounds,
  getStatus,
  getYear,
  getCollegeListForFilter,
  getSkillForFilter,
  getQuestionForFilter,
  getCustomQuestionFilterOptions,
  getWorkExperienceForFilter,
  getLocationForFilter,
  getDegreeForFilter,
  updateNewRound,
  addNewRound,
  downloadTemplate,
  uploadShorlistResult,
  getExportFiledData,
  atsExportCandidate,
  getConflictCandidates,
  updateResolveConflictCandidates,
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewDriveRole)
